module.exports = new __parcel__URL__("intro_bg.0c4b666d.jpg").toString();